import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'
import { useRouterStore } from '@/store/modules/router'
import { sysStore } from '@/store/modules/sys'
import { isExternalLink, pathToCamel } from '@/utils/tool'
import constant from '@/utils/constant'
import { i18n } from '@/i18n'
import palette from '@/components/process-designer/package/designer/plugins/palette'
const projectName = import.meta.env.VITE_PROJECT
NProgress.configure({ showSpinner: false })

const constantRoutes: RouteRecordRaw[] = [
	{
		path: '/redirect',
		component: () => import('../layout/index.vue'),
		children: [
			{
				path: '/redirect/:path(.*)',
				component: () => import('../layout/components/Router/Redirect.vue')
			}
		]
	},
	{
		path: '/iframe/:query?',
		component: () => import('../layout/components/Router/Iframe.vue')
	},
	{
		path: '/login',
		component: () =>
			window.location.origin.includes('hbicc.com') ? import('../views/login2/index_old.vue') : import('../views/login2/index_old.vue')
	},
	// SSO 单点登录中转页：接收统一运营跳转的 ?code=xxx
	{
		path: '/sso',
		component: () => import('../views/sso/index.vue')
	},
	// {
	// 	path: '/login',
	// 	component: () => import('../views/login2/index.vue')
	// },
	{
		path: '/screen',
		component: () => import('../views/screen/index.vue')
	},
	//大屏菜单
	{
		path: '/screen2',
		component: () => import('../views/screen_/index.vue')
	},
	{
		path: '/screen_shunf',
		component: () => import('../views/screen_shunf/index.vue')
	},
	{
		path: '/screen_shunf_sz',
		component: () => import('../views/screen_shunf_sz/index.vue')
	},
	{
		path: '/screen_sdgangt',
		component: () => import('../views/screen_sdgangt/index.vue')
	},
	{
		path: '/screen3d',
		component: () => import('../views/screen_3d/index.vue'),
		meta: {
			title: i18n.global.t('framework.routeTitle.device3d'),
			cache: true
		}
	},
	{
		path: '/cockpit3d',
		meta: {
			title: '3D cockpit',
			cache: true
		},
		component: () => import('../views/cockpit_3d/index.vue')
	},
	{
		path: '/device3d/details',
		meta: {
			title: i18n.global.t('framework.routeTitle.deviceDetail'),
			cache: false
		},
		component: () => import('../views/screen_3d/device_list/details/index.vue')
	},
	// {
	// 	path: '/home',
	// 	component: () => import('../views/home/index.vue'),
	// 	redirect: '/device',
	// 	children: [
	// 		{
	// 			path: '/device',
	// 			meta: {
	// 				title: '设备管理',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/maku/biz_inspect_device/index.vue')
	// 		},
	// 		{
	// 			path: '/diagnose/index',
	// 			meta: {
	// 				title: '诊断分析',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/expdig/diagnose/index.vue')
	// 		},
	// 		{
	// 			path: '/diagnose/records',
	// 			meta: {
	// 				title: '报警记录',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/maku/biz_inspect_cal_warn/index.vue')
	// 		},
	// 		{
	// 			path: '/diagnose/reports',
	// 			meta: {
	// 				title: '诊断报告',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/maku/biz_inspect_device_report/index.vue')
	// 		},
	// 		{
	// 			path: '/device/list',
	// 			meta: {
	// 				title: '设备列表',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/device/list/index.vue')
	// 		},
	// 		{
	// 		},
	// 		{
	// 			path: '/device/selfport',
	// 			meta: {
	// 				title: '传感器自诊断',
	// 				cache: true
	// 			},
	// 			component: () => import('../views/maku/biz_inspect_device_selfport/index.vue')
	// 		}
	// 	]
	// },
	// {
	// 	path: '/login2',
	// 	component: () => import('../views/login2/index.vue')
	// },
	{
		path: '/diag',
		component: () => import('../views/diagnose/index.vue')
	},
	{
		path: '/404',
		component: () => import('../views/404.vue')
	}
]
const screenRoutes: RouteRecordRaw = {
	path: '/',
	component: () => import('../views/home/index.vue'),
	redirect: '/',
	children: [
		// {
		// 	path: '/device/details',
		// 	meta: {
		// 		title: '设备详情',
		// 		cache: false
		// 	},
		// 	component: () => import('../views/maku/device_list/details/index.vue')
		// },
		{
			path: '/factorydetails',
			meta: {
				title: i18n.global.t('framework.routeTitle.factoryDetail'),
				cache: false
			},
			component: () =>
				projectName === 'zy' ? import('../views/screen/factorydetails/index_zy.vue') : import('../views/screen/factorydetails/index.vue')
		},
		{
			path: '/device/annotation',
			meta: {
				title: i18n.global.t('framework.routeTitle.deviceAnnotation'),
				cache: false
			},
			component: () => import('../views/maku/device_annotation/index.vue')
		}
	]
}
const asyncRoutes: RouteRecordRaw = {
	path: '',
	component: () => import('../layout/index.vue'),
	// redirect: '/maku/biz_baobiao/index',
	// redirect: '/screen',
	children: [
		{
			path: '/profile',
			name: 'ProfileIndex',
			component: () => import('../views/profile/index.vue'),
			meta: {
				title: i18n.global.t('framework.routeTitle.profile'),
				cache: true
			}
		},
		{
			path: '/online/form/:id',
			name: 'OnlineForm',
			component: () => import('../views/online/form/index.vue'),
			meta: {
				title: i18n.global.t('framework.routeTitle.onlineForm'),
				cache: false
			}
		},
		{
			path: '/online/report/list/:id',
			name: 'OnlineReport',
			component: () => import('../views/online/report/list.vue'),
			meta: {
				title: i18n.global.t('framework.routeTitle.onlineReport'),
				cache: false
			}
		}
	]
}

// 配置控制台菜单
export const dashboardMenu = [
	{
		id: 100,
		name: 'Dashboard',
		url: null,
		openStyle: 0,
		icon: 'icon-appstore',
		children: [
			{
				id: 101,
				name: '首页',
				url: 'dashboard/index',
				openStyle: 0,
				icon: 'icon-home',
				affix: true
			}
			// {
			// 	id: 102,
			// 	name: '工作台',
			// 	url: 'dashboard/workbench',
			// 	openStyle: 0,
			// 	icon: 'icon-appstore'
			// }
		]
	}
]

// 配置常量菜单
export const constantMenu = [
	// {
	// 	id: 1000,
	// 	name: 'Demo',
	// 	url: null,
	// 	openStyle: 0,
	// 	icon: 'icon-windows',
	// 	children: [
	// 		{
	// 			id: 1001,
	// 			name: 'Icon 图标',
	// 			url: 'demo/icons/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1002,
	// 			name: '表单设计器',
	// 			url: 'demo/formDesign/form',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1003,
	// 			name: '表单生成器',
	// 			url: 'demo/formDesign/generate',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1004,
	// 			name: '二维码生成',
	// 			url: 'demo/qrcode/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1005,
	// 			name: '页面打印',
	// 			url: 'demo/printJs/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1006,
	// 			name: '图片裁剪',
	// 			url: 'demo/cropper/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1007,
	// 			name: '富文本编辑器',
	// 			url: 'demo/editor/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1008,
	// 			name: 'Markdown',
	// 			url: 'demo/markdown/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		},
	// 		{
	// 			id: 1009,
	// 			name: 'ECharts图表',
	// 			url: 'demo/echarts/index',
	// 			openStyle: 0,
	// 			icon: 'icon-unorderedlist'
	// 		}
	// 	]
	// }
]

export const errorRoute: RouteRecordRaw = {
	path: '/:pathMatch(.*)',
	redirect: '/404',
	name: 'error'
}

export const router = createRouter({
	history: createWebHistory(),
	routes: constantRoutes
})

// 白名单列表
const whiteList = ['/login', '/sso', '/webpublish', '/futalimo', '/futafengji', '/futagunyaji', '/futahuizhuanyao', '/preview']

let globalTargetPage: string | null = null
let globalPlatType: string | null = null
let globalShowMenu: string | null = null
let globalShowSettings: string | null = null
let globalThemeType: string | null = null

// 路由跳转前
router.beforeEach(async (to, from, next) => {
	const appStore = useAppStore()
	const userStore = useUserStore()
	const routerStore = useRouterStore()
	const storeSys = sysStore()
	const ssoCode = Array.isArray(to.query.code) ? to.query.code[0] : to.query.code

	// SSO 回调：/?code=xxx 或 任意页面路径/sso?code=xxx → 统一转到 /sso，并记住原始目标页
	const hasSsoCode = typeof ssoCode === 'string' && !!ssoCode.trim()
	const trimmedPath = to.path.replace(/\/+$/, '')
	const isSsoCallbackPath = trimmedPath === '' || (trimmedPath.endsWith('/sso') && trimmedPath !== '/sso')
	if (hasSsoCode && isSsoCallbackPath) {
		// /maku/biz_device/index/sso → /maku/biz_device/index，登录成功后跳回该页面
		const redirect = trimmedPath.endsWith('/sso') ? trimmedPath.slice(0, -4) : ''
		const query: Record<string, string> = { code: ssoCode }
		if (redirect && redirect !== '/') {
			query.redirect = redirect
		}
		next({
			path: '/sso',
			query,
			replace: true
		})
		return
	}

	const targetPage = to.query.page as string
	const password = to.query.password as string
	const userName = to.query.user_name as string
	const device_id = to?.query.device_id ?? ''
	const isHiddenTree = to.query.is_hidden_true as string
	const showMenu = to.query.show_menu as string
	const showSettings = to.query.show_settings as string
	const customTitle = to.query.ht_title as string
	const theme = (to?.query?.theme as string) || globalThemeType
	const themeType = theme === 'blue' ? 'bluex' : theme

	if (themeType) {
		appStore.setThemeType(themeType)
		globalThemeType = themeType
	}

	if (customTitle) {
		localStorage.setItem('customTitle', customTitle)
	}

	if (targetPage && password && userName) {
		try {
			// 导入登录相关模块
			const { useTenantInfoApi } = await import('@/api/tenant/tenant')
			const { sm2Encrypt } = await import('@/utils/smCrypto')
			const cache = await import('@/utils/cache')
			const { data: tenantData } = await useTenantInfoApi()
			cache.default.setTenantId(tenantData.tenantId)

			// 执行登录
			const loginData = {
				username: userName,
				password: password,
				key: '',
				captcha: '',
				tenantId: tenantData.tenantId
			}

			await userStore.accountLoginAction(loginData)
			await userStore.getUserInfoAction()

			// 设置全局参数
			if (targetPage) {
				globalPlatType = to.query.plat_type as string
				if (isHiddenTree === 'true') {
					globalTargetPage = targetPage + (targetPage.includes('?') ? '&' : '?') + 'isHiddenTree=true'
				} else {
					globalTargetPage = targetPage
				}
			}
			if (showMenu) {
				globalShowMenu = showMenu
			}
			if (showSettings) {
				globalShowSettings = showSettings
			}

			// 特殊处理设备详情页面
			if (device_id && targetPage === '/device/details') {
				next('device/details?id=' + device_id)
				return
			}

			// 登录成功后跳转到目标页面
			let redirectUrl = targetPage
			if (isHiddenTree === 'true') {
				redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + 'isHiddenTree=true'
			}
			if (themeType) {
				redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + 'theme=' + themeType
			}
			next(redirectUrl)
			return
		} catch (error) {
			console.error('自动登录失败:', error)
		}
	}
	// 设置全局参数（非自动登录情况）
	if (targetPage) {
		globalPlatType = to.query.plat_type as string
		if (isHiddenTree === 'true') {
			globalTargetPage = targetPage + (targetPage.includes('?') ? '&' : '?') + 'isHiddenTree=true'
		} else {
			globalTargetPage = targetPage
		}
	}
	if (showMenu) {
		globalShowMenu = showMenu
	}
	if (showSettings) {
		globalShowSettings = showSettings
	}
	if (device_id && targetPage === '/device/details') {
		next('device/details?id=' + device_id)
		return
	}
	if (to.path === '/' && userStore.token !== '') {
		// 检查是否有page参数需要跳转
		if (targetPage) {
			let redirectUrl = targetPage
			if (isHiddenTree === 'true') {
				redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + 'isHiddenTree=true'
			}
			if (themeType) {
				redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + 'theme=' + themeType
			}
			next(redirectUrl)
		} else {
			// 根据缓存的平台信息进行重定向
			next(constant.getPlatformPage())
		}
		return
	}

	NProgress.start()
	// token存在的情况
	if (userStore.token) {
		if (to.path === '/login') {
			// 根据缓存的平台信息进行重定向
			next(constant.getPlatformPage())
			return
		}

		if (to.path === '/screen' || to.path === '/screen2') {
			await loadMenuAndRoutes(
				userStore,
				routerStore,
				appStore,
				storeSys,
				to,
				globalTargetPage,
				globalPlatType,
				globalShowMenu,
				globalShowSettings,
				globalThemeType
			)
			console.log('to.path------', routerStore)
			if (routerStore.menuRoutes[0]?.children?.length) {
				let redirectUrl = routerStore.menuRoutes[0].children[0].path
				if (themeType) {
					redirectUrl += (redirectUrl.includes('?') ? '&' : '?') + 'theme=' + themeType
				}
				next(redirectUrl)
			} else {
				next()
			}
			return
		}

		if (to.path === '/diag') {
			next()
			return
		}

		// 用户信息不存在或路由刷新时重新加载
		if (!userStore.user.id || !router.hasRoute('error')) {
			try {
				console.log(targetPage, 'to')
				await loadMenuAndRoutes(
					userStore,
					routerStore,
					appStore,
					storeSys,
					to,
					globalTargetPage,
					globalPlatType,
					globalShowMenu,
					globalShowSettings,
					globalThemeType
				)
				next({ ...to, replace: true })
			} catch (error) {
				userStore?.setToken('')
				next('/login')
				return Promise.reject(error)
			}
		} else {
			next()
		}
		appStore.getDictListAction()
	} else {
		// 没有token的情况下，可以进入白名单
		if (whiteList.some(path => to.path.startsWith(path))) {
			next()
		} else {
			if (targetPage && userName) {
				const loginQuery: any = {
					page: targetPage,
					user_name: userName
				}
				if (isHiddenTree === 'true') {
					loginQuery.isHiddenTree = 'true'
				}
				next({
					path: '/login',
					query: loginQuery
				})
			} else {
				next('/login')
			}
		}
	}
})

async function loadMenuAndRoutes(
	userStore: any,
	routerStore: any,
	appStore: any,
	storeSys: any,
	to?: any,
	targetPageParam?: string | null,
	platType?: string | null,
	showMenu?: string | null,
	showSettings?: string | null,
	themeTypeParam?: string | null
) {
	// 确保用户信息和权限已获取
	if (!userStore.user.id || !userStore.authorityList.length) {
		await Promise.all([userStore.getUserInfoAction(), userStore.getAuthorityListAction()])
		appStore.getDictListAction()
		storeSys.getEigAction()
		storeSys.getWaveAction()
	}
	// 加载菜单数据
	const menuRoutes = await routerStore.getMenuRoutes()

	// 获取扁平化路由，将多级路由转换成一级路由
	const keepAliveRoutes = getKeepAliveRoutes(menuRoutes, []).filter((item: any) => item.meta.url !== '/screen' && item.meta.url !== '/screen3d')
	console.log(keepAliveRoutes)
	console.log(to, 'to--------')
	const currentTargetPage = targetPageParam || to?.query?.page
	const currentPlatType = platType || to?.query?.plat_type || appStore.theme.platType
	const currentShowMenu = showMenu || to?.query?.show_menu
	const currentShowSettings = showSettings || to?.query?.show_settings
	const themeType = themeTypeParam || to?.query?.theme
	if (currentTargetPage) {
		const currentTheme = { ...appStore.theme }
		if (currentShowMenu) {
			currentTheme.isLayoutView = true
		} else {
			currentTheme.isLayoutView = false
		}
		if (currentShowSettings) {
			currentTheme.isSettings = true
		}
		appStore.setTheme(currentTheme)
		keepAliveRoutes.forEach((route: any) => {
			if (route.path === currentTargetPage || route.meta?.url === currentTargetPage.replace('/', '')) {
				if (currentPlatType == 0 || themeType) {
					route.platType = 0
					if (route.meta) {
						route.meta.platType = 0
					}
				} else {
					route.platType = 1
				}
			}
		})

		if (targetPageParam) {
			globalTargetPage = null
		}
	} else {
		// keepAliveRoutes.forEach((route: any) => {
		// 	if (route.path) {
		// 		route.platType = 0
		// 		if (route.meta) {
		// 			route.meta.platType = 0
		// 		}
		// 	}
		// })
	}

	const screenList = keepAliveRoutes.filter((item: any) => item.platType === 1)
	const otherList = keepAliveRoutes.filter((item: any) => item.platType !== 1)

	// 判断screenList中是否存在路径为'deviceft_list'的路由
	const hasDeviceftList = screenList.some((item: any) => item.path === '/maku/device_list/index' || item.path === '/maku/deviceft_list/index')

	const deviceDetailsRoute = {
		path: '/device/details',
		meta: {
			title: i18n.global.t('framework.routeTitle.deviceDetail'),
			cache: false
		},
		component: () => import('../views/maku/device_list/details/index-ht.vue')
	}

	if (hasDeviceftList) {
		// 如果screenList中有device_list，将设备详情添加到screenRoutes.children
		asyncRoutes.children = asyncRoutes.children?.filter(
			item => item.path === '/profile' || item.path === '/online/form/:id' || item.path === '/online/report/list/:id'
		)
		asyncRoutes.children?.push(...otherList)

		screenRoutes.children = [
			{
				path: '/deviceft_list',
				meta: {
					title: i18n.global.t('framework.routeTitle.deviceList'),
					cache: false
				},
				component: () => import('../views/maku/deviceft_list/index.vue')
			},
			{
				path: '/device/details',
				meta: {
					title: i18n.global.t('framework.routeTitle.deviceDetail'),
					cache: false
				},
				component: () => import('../views/maku/device_list/details/index.vue')
			},
			{
				path: '/factorydetails',
				meta: {
					title: i18n.global.t('framework.routeTitle.factoryDetail'),
					cache: false
				},
				component: () => import('../views/screen/factorydetails/index.vue')
			},
			{
				path: '/device/annotation',
				meta: {
					title: i18n.global.t('framework.routeTitle.deviceAnnotation'),
					cache: false
				},
				component: () => import('../views/maku/device_annotation/index.vue')
			}
		]
	} else {
		// 如果screenList中没有device_list，将设备详情添加到asyncRoutes.children
		asyncRoutes.children = asyncRoutes.children?.filter(
			item => item.path === '/profile' || item.path === '/online/form/:id' || item.path === '/online/report/list/:id'
		)
		asyncRoutes.children?.push(deviceDetailsRoute, ...otherList)

		screenRoutes.children = [
			{
				path: '/deviceft_list',
				meta: {
					title: i18n.global.t('framework.routeTitle.deviceList'),
					cache: false
				},
				component: () => import('../views/maku/deviceft_list/index.vue')
			},
			{
				path: '/factorydetails',
				meta: {
					title: i18n.global.t('framework.routeTitle.factoryDetail'),
					cache: false
				},
				component: () => import('../views/screen/factorydetails/index.vue')
			},
			{
				path: '/device/annotation',
				meta: {
					title: i18n.global.t('framework.routeTitle.deviceAnnotation'),
					cache: false
				},
				component: () => import('../views/maku/device_annotation/index.vue')
			}
		]
	}
	screenRoutes.children?.push(...screenList)

	// 删除现有路由，避免重复
	if (router.hasRoute(asyncRoutes.path)) {
		router.removeRoute(asyncRoutes.path)
	}
	if (router.hasRoute(screenRoutes.path)) {
		router.removeRoute(screenRoutes.path)
	}
	if (router.hasRoute('error')) {
		router.removeRoute('error')
	}

	// 添加路由
	router.addRoute(screenRoutes)
	router.addRoute(asyncRoutes)
	router.addRoute(errorRoute)

	// 保存路由数据
	routerStore.setRoutes(constantRoutes.concat(asyncRoutes, screenRoutes))
	routerStore.setSearchMenu(keepAliveRoutes)
}

// 路由加载后
router.afterEach(() => {
	NProgress.done()
	// const customTitle = localStorage.getItem('customTitle')
	// if (customTitle) {
	// 	document.title = customTitle
	// }
})

// 获取扁平化路由，将多级路由转换成一级路由
export const getKeepAliveRoutes = (rs: RouteRecordRaw[], breadcrumb: string[]): RouteRecordRaw[] => {
	const routerList: RouteRecordRaw[] = []

	rs.forEach((item: any) => {
		// 创建面包屑的副本，避免共享引用
		const currentBreadcrumb = [...breadcrumb]

		if (item.meta.title) {
			currentBreadcrumb.push(item.meta.title)
		}

		if (item.children && item.children.length > 0) {
			routerList.push(...getKeepAliveRoutes(item.children, currentBreadcrumb))
		} else {
			// 清空现有面包屑，防止重复累积
			item.meta.breadcrumb.length = 0
			item.meta.breadcrumb.push(...currentBreadcrumb)
			routerList.push(item)
		}
	})
	return routerList
}

// 加载vue组件
export interface ModuleMap {
	[key: string]: any
}

export const layoutModules = () => {
	return import.meta.glob('/src/views/**/*.vue')
}

// 根据路径，动态获取vue组件
const getDynamicComponent = (path: string): any => {
	const modules: ModuleMap = layoutModules()
	return modules[`/src/views/${path}.vue`]
}

// 根据菜单列表，生成路由数据
export const generateRoutes = (menuList: any): RouteRecordRaw[] => {
	const routerList: RouteRecordRaw[] = []

	menuList.forEach((menu: any) => {
		let component
		let path
		if (menu.children && menu.children.length > 0) {
			component = () => import('@/layout/index.vue')
			path = '/p/' + menu.id
		} else {
			// 判断是否iframe
			if (isIframeUrl(menu)) {
				component = () => import('@/layout/components/Router/Iframe.vue')
				path = '/layout-iframe/' + menu.id
			} else if (menu.url?.indexOf('online/form/') != -1) {
				component = () => import('@/views/online/form/index.vue')
				path = '/' + menu.url
			} else if (menu.url?.indexOf('online/report/list/') != -1) {
				component = () => import('@/views/online/report/list.vue')
				path = '/' + menu.url
			} else if (import.meta.env.VITE_PROJECT === 'ft' && menu.url?.indexOf('maku/device_list/') != -1) {
				component = () => import('../views/maku/deviceft_list/index.vue')
				path = '/' + menu.url
			} else {
				component = getDynamicComponent(menu.url)
				path = '/' + menu.url
			}
		}
		const route: any = {
			path: path,
			name: pathToCamel(path),
			component: component,
			children: [],
			id: menu.id,
			platType: menu.platType,
			meta: {
				title: menu.name,
				icon: menu.icon,
				platType: menu.platType,
				id: '' + menu.id,
				url: menu.url,
				cache: true,
				newOpen: menu.openStyle === 1,
				affix: menu.affix,
				breadcrumb: []
			}
		}

		// 有子菜单的情况
		if (menu.children && menu.children.length > 0) {
			route.children?.push(...generateRoutes(menu.children))
		}

		routerList.push(route)
	})
	return routerList
}

// 判断是否iframe
const isIframeUrl = (menu: any): boolean => {
	// 如果是新页面打开，则不用iframe
	if (menu.openStyle === 1) {
		return false
	}

	// 是否外部链接
	return isExternalLink(menu.url)
}
